module.exports = __webpack_public_path__ + "static/media/5-1-redcube.7eb98464.png";